module.exports = __webpack_public_path__ + "@/assets/img/logo-white.fce7f02d.png";